module.exports = __webpack_public_path__ + "img/Frame-10.cb9d205f.svg";